import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Topbar from "../../../components/Topbar/Topbar";
import { useGlobalContext } from "../../../Services/PaginationGlobal";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import {
  delete_icon,
  dummyimage,
  edit_icon,
  Search_icon,
  vedio,
} from "../../../assets/img";
import { Table } from "../../../components/Table/Table";
import DateRange from "../../../components/DateRange/DateRange";
import Select from "react-select";
import {
  customFilterOption,
  formatOptionLabel,
} from "../../../components/StaticData";
import { URLS } from "../../../Services/Constant";
import { deletes, get, post } from "../../../Services/ApiHandler";
import { toast } from "react-toastify";
import moment from "moment";
import { checkPermission } from "../../redux/api/PermissionManager";

const VideoBannersList = () => {
  const navigate = useNavigate();

  const { paginationData, setpaginationData } = useGlobalContext();
  const { pathname } = useLocation();
  const path = pathname?.replace("/", "");
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  });
  const [count, setCount] = useState(0);
  const [selectedFilter, setSelectedFilter] = useState({
    from: paginationData?.[path]?.from ?? "",
    to: paginationData?.[path]?.to ?? "",
    city: "",
    state: "",
    search: paginationData?.[path]?.search ?? "",
  });
  const [optionsList, setOptionsList] = useState({
    states: [],
    cities: [],
  });

  const [search, setSearch] = useState("");

  const [editId, setEditId] = useState(null);
  const popupInputRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState(dummyimage);
  const [defaultBanner, setDefaultBanner] = useState({});
  const [bannerPopup, setBannerPopup] = useState(false);

  const [duration, setDuration] = useState();

  const [list, setList] = useState([]);
  const [popup, setPopup] = useState(false);

  const handleStatus = async (id, status) => {
    let res = await post(`${URLS.BANNER_MASTER}${id}/status/`, {
      status: status ? 0 : 1,
    });
    if (res?.status === "success") {
      toast.success(res?.message);
      getList();
    }
  };

  const columns = useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "S.No",
        Cell: ({ row }) => {
          return <p className="red">{row.index + 1 + (page - 1) * 10}</p>;
        },
      },
      {
        Header: "Video",
        accessor: "image",
        Cell: ({ value, row }) => {
          return value ? (
            <video
              width="170"
              height="100"
              controls
              className="list-video"
              style={{ objectFit: "cover", borderRadius: "6px" }}
            >
              <source src={value} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          ) : (
            <img
              src={vedio}
              alt="placeholder"
              className="list-img"
              style={{ width: "80px", height: "40px", objectFit: "cover" }}
            />
          );
        },
      },
      {
        Header: "State",
        accessor: "state",
        Cell: ({ value, row }) => {
          const states = row?.original?.states?.map((ele) => ele?.name) || [];

          return (
            <div>
              {row?.original?.all_states ? (
                <p>All States</p>
              ) : (
                <div>
                  {states.map((stateName, index) => (
                    <p key={index}>{stateName}</p>
                  ))}
                </div>
              )}
            </div>
          );
        },

        // Cell: ({ value, row }) => {
        //   let states = row?.original?.states.map((ele) => {
        //     ele?.name;
        //   });
        //   console.log("====================================");
        //   console.log("Sdjaksjdlksalda", value, row?.original?.states, states);
        //   console.log("====================================");
        //    <p>{row?.original?.all_states ? "All State" :
        //     row?.original?.states, states.map((ele) => {
        //        <p>{ele?.name }</p>
        //   })

        //   }</p>;
        // },
      },
      {
        Header: "City",
        accessor: "city",
        Cell: ({ value, row }) => {
          const citys = row?.original?.cities?.map((ele) => ele?.name) || [];
          return (
            <div>
              {row?.original?.cities.length == 0 ||
              row?.original?.states.length > 1 ? (
                <p>All City</p>
              ) : (
                <div>
                  {/* {citys.map((stateName, index) => ( */}
                  <p>{citys.length}</p>
                  {/* ))} */}
                </div>
              )}
            </div>
            // <p>
            //   {
            //     ? "All City"
            //     : value}
            // </p>
          );
        },
      },
      {
        Header: "Count",
        accessor: "count",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "From Date",
        accessor: "start_date",
        Cell: ({ value, row }) => {
          return <p>{moment(value).format("DD-MM-YYYY")}</p>;
        },
      },
      {
        Header: "To Date",
        accessor: "end_date",
        Cell: ({ value, row }) => {
          return <p>{moment(value).format("DD-MM-YYYY")}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  handleStatus(row.original.id, value);
                }}
                className={`${
                  value ? "active-btn" : "deactive-btn"
                } border-0  fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13 fs-xxl-18`}
              >
                {value ? " Active" : "De-active"}
              </button>
            </div>
          );
        },
      },
    ];
    let action = {
      Header: "Action",
      accessor: "",
      Cell: ({ value, row }) => {
        return (
          <React.Fragment>
            <div className="d-flex ac-js gap-3">
              <button
                onClick={() => {
                  navigate("/vedio-add", {
                    state: { type: "edit", data: row.original },
                  });
                }}
                className="cust-btn "
              >
                <img src={edit_icon} alt="" className=" edit-btn " />
              </button>

              <button
                onClick={() => setPopup(row.original.id)}
                className="cust-btn "
              >
                <img src={delete_icon} alt="" className=" edit-btn " />
              </button>
            </div>
          </React.Fragment>
        );
      },
    };
    // return checkPermission("CAN-EDIT-BANNER") ||
    //   checkPermission("CAN-DELETE-BANNER")
    //   ? [...d, action]
    //   : d;
    return [...d, action];
  }, [page]);

  const handleChangeFilter = (name, val) => {
    if (name !== "from" && val) setPage(1);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };

  useEffect(() => {
    getLocationsList(2);
    getCities();
    // fetch();
  }, []);

  //get  locations
  const getLocationsList = async (type, parent_id) => {
    let url = `${URLS.LOCATION + "?type=" + type}${
      parent_id ? "&parent_id=" + parent_id : ""
    }`;
    const res = await get(url);
    console.log("locations list", res, type, parent_id);
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.name };
      });
      if (type === 2) {
        setOptionsList((prev) => ({ ...prev, states: modifiedList }));
      } else if (type === 3) {
        setOptionsList((prev) => ({ ...prev, cities: modifiedList }));
      } else {
        setOptionsList((prev) => ({ ...prev, areas: modifiedList }));
      }
    }
  };

  const getCities = async () => {
    const res = await get(URLS.PROPERTY_CITIES);
    console.log("properties cities", res);
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.name };
      });
      setOptionsList((prev) => ({ ...prev, cities: modifiedList }));
    }
  };

  useEffect(() => {
    getList(page);
    setpaginationData((prev) => ({
      ...prev,
      [path]: { page: page, search: selectedFilter.search },
    }));
  }, [selectedFilter.city, selectedFilter.state, selectedFilter.search, page]);

  useEffect(() => {
    const { from, to } = selectedFilter;
    if ((from && to) || (!from && !to)) getList(page);
  }, [selectedFilter.from, selectedFilter.to]);

  const getList = async (pageNumber = 1) => {
    const { city, from, state, search, to } = selectedFilter;
    const payload = new FormData();
    payload.append("type", 3);
    if (search) {
      payload.append("search", search);
    }
    if ((from && to) || (!from && !to)) {
      payload.append("from_date", from);
      payload.append("to_date", to);
    }
    if (city) {
      payload.append("city", city?.value);
    }
    if (state) {
      payload.append("state", state?.value);
    }
    const res = await post(URLS.BANNERS + "?page=" + pageNumber, payload);
    console.log("property Banners", res);
    if (res?.status === "success") {
      setCount(res?.count);
      setPagination({
        current_page: pageNumber,
        last_page: res?.total_pages,
      });
      setList(res?.data);
    }
  };

  const handleDelete = async (id) => {
    let res = await deletes(`${URLS.BANNER_MASTER}${id}/delete/`);
    if (res?.status === "success") {
      setPopup(false);
      toast.success(res?.message);
      getList();
    }
  };

  const fetch = async () => {
    try {
      const url = search
        ? `${URLS.MASTERURL}?type=${17}&search=${search}`
        : `${URLS.MASTERURL}?type=${17}`;
      const res = await get(url);
      if (res?.status == "success") {
        setDefaultBanner({
          icon: res?.data[0]?.icon,
        });
        setEditId(res?.data[0]?.id);
      }
      console.log(res, "defaultVideoRes");
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetch();
  }, [search, editId]);

  const handleVideoChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    if (!file.type.startsWith("video/")) {
      toast.error("Please select a valid video file");
      return;
    }

    if (file.size > 15 * 1024 * 1024) {
      toast.error("Video size must be less than 15MB");
      return;
    }

    const video = document.createElement("video");
    const videoUrl = URL.createObjectURL(file);

    video.preload = "metadata";
    video.src = videoUrl;

    video.onloadedmetadata = () => {
      URL.revokeObjectURL(videoUrl);

      const durationVal = Math.floor(video.duration);

      setDuration(durationVal);
    };

    setSelectedImage(file);
  };

  console.log("selecetdImage", selectedImage);
  console.log("duration", duration);

  const handleUpload = async () => {
    const formdata = new FormData();
    formdata.append("type", 17);
    if (selectedImage && typeof selectedImage !== "string") {
      formdata.append("icon", selectedImage);
    }
    formdata.append("name", duration);
    const res = await post(`${URLS.MASTERURL}${editId}/edit/`, formdata);
    if (res?.status == "success") {
      toast.success(res?.message);
      setBannerPopup(false);
      setSelectedImage({});
      fetch();
    }
    // window.location.reload();
  };

  // console.log("selectedImage", selectedImage);

  return (
    <div>
      <Topbar header={"Video Banner"} subHead={"Video Property Banner"} />
      <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
        Total:{count}
      </h2>
      <div className="d-flex ac-je mt-3 gap-1 flex-wrap">
        <DateRange
          setFromDate={(date) => {
            handleChangeFilter("from", date);
          }}
          setToDate={(date) => {
            handleChangeFilter("to", date);
          }}
        />
        <Select
          className="location-search"
          options={optionsList?.cities}
          placeholder={"City"}
          isClearable
          onChange={(e) => {
            handleChangeFilter("city", e);
          }}
          value={selectedFilter?.city}
        />
        <Select
          className="location-search"
          options={optionsList?.states}
          isClearable
          onChange={(e) => {
            handleChangeFilter("state", e);
          }}
          formatOptionLabel={formatOptionLabel}
          filterOption={customFilterOption}
          value={selectedFilter?.state}
          placeholder={"State"}
        />
        <div className="search-input">
          <input
            onChange={(e) => {
              handleChangeFilter("search", e.target.value);
            }}
            type="text"
            placeholder="Search"
            style={{ border: "none", width: "150px" }}
            value={selectedFilter.search}
          />
          <img alt="" src={Search_icon} className="search" />
        </div>
        <button
          onClick={() =>
            navigate("/vedio-add", {
              state: { type: "add" },
            })
          }
          className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn "
        >
          {" "}
          + Add New
        </button>
      </div>

      <div className="mt-5">
        <h2 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20">
          Default Video Banner
        </h2>
        <p className="f3 fs-sm-10 fs-md-10 fs-lg-11 fs-xl-12 fs-xxl-14 mt-2 text-start err ">
          {" "}
          Max Upload Size : 15MB
        </p>

        <div
          className="mt-3"
          style={{
            border: "1px solid #C5C5C5",
            borderRadius: "20px",
            width: "25%",
          }}
        >
          <div
            className="d-flex ac-jb p-2"
            style={{ borderBottom: "1px solid #C5C5C5" }}
          >
            <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 w-60">
              Video
            </p>

            {(checkPermission("CAN-EDIT-VIDEO") ||
              checkPermission("CAN-ADD-VIDEO")) && (
              <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 w-40">
                Action
              </p>
            )}
          </div>
          <div className="d-flex ac-jb p-2">
            <div className="w-60">
              <div className=" mb-2 w-100 d-flex ac-jb">
                <div className="position-relative w-100">
                  <div className="d-flex ac-jb w-100">
                    <div>
                      {typeof defaultBanner?.icon === "string" ? (
                        // Case 1: video URL from backend
                        <video
                          src={defaultBanner.icon}
                          width="120"
                          height="80"
                          controls
                          muted
                        />
                      ) : defaultBanner?.icon instanceof File ? (
                        // Case 2: user uploaded video
                        <video
                          src={URL.createObjectURL(defaultBanner.icon)}
                          width="120"
                          height="80"
                          controls
                          muted
                        />
                      ) : (
                        // Case 3: no video
                        <div
                          style={{
                            width: "60px",
                            height: "50px",
                            background: "#f5f5f5",
                            border: "1px dashed #ccc",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "10px",
                            color: "#777",
                          }}
                        >
                          No video
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {checkPermission("CAN-EDIT-VIDEO") ||
              (checkPermission("CAN-ADD-VIDEO") && (
                <button className="cust-btn d-flex ac-js w-40">
                  <img
                    src={edit_icon}
                    onClick={() => {
                      setSelectedImage(defaultBanner?.icon);
                      setBannerPopup(true);
                    }}
                    alt=""
                    className="mx-2 edit-btn "
                  />
                </button>
              ))}
          </div>
        </div>
      </div>
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={list}
        show={false}
      />

      {bannerPopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-jb">
              <p className="f4 text-start fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20">
                Edit
              </p>
              <CloseSharpIcon
                onClick={() => setBannerPopup(false)}
                className="pointer"
              />
            </div>

            <div className="px-2 mt-4">
              <p className="px-5 f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 text-start">
                Video
              </p>

              <div className="d-flex ac-jb gap-3 align-items-center px-5">
                {/* Video Preview */}
                <div className="position-relative">
                  {typeof selectedImage === "string" ? (
                    <video
                      src={selectedImage}
                      width="120"
                      height="80"
                      controls
                      muted
                      style={{ borderRadius: "10px" }}
                    />
                  ) : selectedImage instanceof File ? (
                    <video
                      src={URL.createObjectURL(selectedImage)}
                      width="120"
                      height="80"
                      controls
                      muted
                      style={{ borderRadius: "10px" }}
                    />
                  ) : (
                    <div
                      style={{
                        width: "120px",
                        height: "80px",
                        borderRadius: "10px",
                        background: "#f5f5f5",
                        border: "2px dashed #ccc",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "12px",
                        color: "#777",
                      }}
                    >
                      No video
                    </div>
                  )}
                </div>

                {/* Edit Icon */}
                <button
                  className="cust-btn"
                  onClick={() => popupInputRef.current.click()}
                >
                  <img src={edit_icon} alt="edit" className="edit-btn" />
                </button>

                {/* Hidden File Input */}
                <input
                  ref={popupInputRef}
                  type="file"
                  hidden
                  accept="video/*"
                  onChange={handleVideoChange}
                />
              </div>

              <button
                onClick={handleUpload}
                className="submit-btn f2 w-60 mt-3"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button
                onClick={() => handleDelete(popup)}
                className="add-btn w-40"
              >
                Yes
              </button>
              <button
                onClick={() => {
                  setPopup(false);
                }}
                className="back-btn f2 w-40"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoBannersList;
